module.exports = __webpack_public_path__ + "static/img/yiqingtangTe.3d89064.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/yiBrand/yiqingtangTe.png
// module id = gzlD
// module chunks = 0